export const REMOVAL_CONFIRMATION_TOASTS = [
    {
        title: '🔄 ¿Estás segur@ de eliminar este producto?',
        message: '⚠️ No siempre se presenta otra oportunidad como esta...',
        buttonTrue: '🗑️ Sí, eliminar',
        buttonFalse: '♻️ Mejor lo conservo 😊'
    },
    {
        title: '😬 ¿Eliminarlo ahora? Piénsalo dos veces.',
        message: '💡 Este tipo de cosas no aparecen todos los días.',
        buttonTrue: '🗑️ Eliminar de todos modos',
        buttonFalse: '🛒 Conservarlo por ahora 😌'
    },
    {
        title: '🧐 Estás a un paso de dejarlo ir',
        message: '⏱️ Una decisión rápida puede cambiarlo todo.',
        buttonTrue: '❌ Sí, eliminar',
        buttonFalse: '🔄 No, mantenerlo 🙂'
    },
    {
        title: '🛑 ¿Realmente quieres quitarlo del carrito?',
        message: '🧭 Tal vez lo estuviste buscando por mucho tiempo...',
        buttonTrue: '🗑️ Eliminar',
        buttonFalse: '💭 Voy a pensarlo 😅'
    },
    {
        title: '🤔 Esto podría ser justo lo que estabas buscando',
        message: '🌟 ¿Seguro que quieres dejarlo pasar?',
        buttonTrue: '❌ Eliminar',
        buttonFalse: '🛍️ Volver al carrito 😄'
    },
    {
        title: '🤨 ¿Estás segur@ de hacer esto?',
        message: '✨ Ese producto tenía tu nombre escrito...',
        buttonTrue: '🗑️ Eliminar ahora',
        buttonFalse: '🙌 Conservarlo, por supuesto 😊'
    },
    {
        title: '😅 Uy, casi lo pierdes',
        message: '🧲 No todos los días se encuentra algo así.',
        buttonTrue: '🗑️ Sí, quitarlo',
        buttonFalse: '💖 Mejor me lo quedo 😌'
    },
    {
        title: '🤷‍♂️ ¿Eliminarlo? No tan rápido...',
        message: '🚦 A veces lo mejor es darle otra vuelta.',
        buttonTrue: '🗑️ Eliminar igual',
        buttonFalse: '🔁 Dejarlo en el carrito 🙂'
    },
    {
        title: '🧡 Eso que estás quitando… podría hacerte feliz',
        message: '💭 No tomes decisiones impulsivas.',
        buttonTrue: '🗑️ Eliminar',
        buttonFalse: '🛒 Mejor no, lo dejo 😇'
    },
    {
        title: '🧐 Este artículo llamó tu atención por algo',
        message: '🎁 ¿Y si te sorprende cuando lo tengas?',
        buttonTrue: '❌ Eliminar',
        buttonFalse: '😊 Vale la pena conservarlo'
    }
];

export const PRODUCT_LOSS_WARNING_TOASTS = [
    {
        title: '🛍️ Este producto estaba a punto de ser tuyo',
        message:
            '⏳ Al eliminarlo podrías estar dejando pasar algo que no vuelve.',
        buttonTrue: '❌ Eliminar de todos modos',
        buttonFalse: '🔙 Volver al carrito 😊'
    },
    {
        title: '⛔ ¡Uy! Estás por eliminar algo especial',
        message: '🕰️ No sabemos si lo volverás a ver.',
        buttonTrue: '🗑️ Sí, eliminar',
        buttonFalse: '🛒 Lo quiero en el carrito 😍'
    },
    {
        title: '😢 Eliminarlo podría ser un adiós definitivo',
        message: '🚪 Una vez fuera... puede que no vuelva.',
        buttonTrue: '❌ Eliminar igualmente',
        buttonFalse: '⬅️ Conservar producto 😇'
    },
    {
        title: '🎯 Casi lo tenías...',
        message: '📦 Ese producto estaba listo para ser tuyo.',
        buttonTrue: '❌ Eliminar',
        buttonFalse: '🛍️ No, aún lo quiero 😁'
    },
    {
        title: '⚠️ No hay segundas oportunidades para algunos productos',
        message: '📉 Si lo sacas del carrito, podría no volver.',
        buttonTrue: '🗑️ Eliminar ahora',
        buttonFalse: '🛒 Déjalo ahí por ahora 🙂'
    },
    {
        title: '😬 ¡Estás por dejarlo ir!',
        message: '🚪 A veces, lo que dejas ir no regresa...',
        buttonTrue: '❌ Sí, eliminar',
        buttonFalse: '🛍️ Mejor me lo quedo 😌'
    },
    {
        title: '😱 ¡Ese producto estaba casi en tus manos!',
        message: '📦 Unos clics más y era tuyo.',
        buttonTrue: '🗑️ Eliminar',
        buttonFalse: '😊 Lo quiero todavía'
    },
    {
        title: '🕳️ Una vez que se va... se fue',
        message: '📉 Eliminarlo puede ser definitivo.',
        buttonTrue: '❌ Eliminar igualmente',
        buttonFalse: '🛒 No lo suelto 😄'
    },
    {
        title: '🎯 Lo encontraste por algo',
        message: '🔍 ¿Seguro que no lo vas a necesitar?',
        buttonTrue: '🗑️ Eliminar',
        buttonFalse: '🤗 Seguir en el carrito'
    },
    {
        title: '🛒 Tu carrito se sentirá vacío sin él',
        message: '😭 Ya le habías hecho un espacio...',
        buttonTrue: '❌ Eliminar ahora',
        buttonFalse: '💞 Lo dejo conmigo 😊'
    }
];
